import { Sidebar } from "$/lib/components";
import Flexbox from "$/lib/components/common/Flexbox";
import ProtectedRoute from "$/lib/guard/ProtectedRoute";
import CompanyIcon from "$/lib/icons/CompanyIcon";
import ConsultantIcon from "$/lib/icons/ConsultantIcon";
import ContractIcon from "$/lib/icons/ContractIcon";
import { IS_PRODUCTION } from "$/lib/utils/constants/misc.constants";
import { CONSULTANT_ROUTES } from "$/lib/utils/constants/routes.constants";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_consultant_layout")({
  component: LayoutComponent,
});

const SIDEBAR_ITEMS = [
  ...[
    {
      label: "Organisations",
      href: CONSULTANT_ROUTES.ORGANIZATIONS,
      Icon: CompanyIcon,
    },
    {
      label: "Les consultants",
      href: CONSULTANT_ROUTES.CONSULTANTS,
      Icon: ConsultantIcon,
    },
  ],
  ...(!IS_PRODUCTION
    ? [
        {
          label: "Contrats",
          href: CONSULTANT_ROUTES.CONTRACTS,
          Icon: ContractIcon,
        },
      ]
    : []),
];

function LayoutComponent() {
  return (
    <ProtectedRoute layout="consultant">
      <Flexbox row>
        <Sidebar routes={SIDEBAR_ITEMS} />
        <Flexbox fullWidth className="overflow-auto p-6 min-h-screen">
          <Outlet />
        </Flexbox>
      </Flexbox>
    </ProtectedRoute>
  );
}
